<template>
    <button
        :style="{
            'background-image': 'url(' + $laroute.route('storage.files.show', {
                file: file.uuid,
                width,
                height,
                greyscale: !!file.erased_at
            }) + ')'
        }"
        :class="file.mime_type === 'application/pdf' ? 'bg-top' : 'bg-center'"
        class="relative block w-full h-32 bg-white bg-cover rounded shadow hover:bg-blue-bg focus:outline-none focus:shadow-outline"
        @click.prevent="open"
    >
        <div
            v-if="!!file.erased_at"
            class="absolute bottom-0 right-0 flex items-center justify-center m-2"
        >
            <div class="p-1 bg-white rounded">
                <base-svg
                    name="icon-archive"
                    class="w-6 h-6"
                />
            </div>
        </div>

        <modal-blue
            v-if="show_modal"
            :is-open="show_modal"
            max-w="2xl"
            @close="show_modal = false"
        >
            <div slot-scope="{ close }">
                <div class="px-4 py-6 sm:px-6">
                    <with-dimensions :once="true">
                        <div
                            slot-scope="{ width: _width }"
                            class="mb-6 text-center"
                        >
                            <img
                                v-if="_width"
                                :src="$laroute.route('storage.files.show', {
                                    file: file.uuid,
                                    width: _width
                                })"
                                class="inline-block mx-auto border rounded"
                            >
                        </div>
                    </with-dimensions>

                    <grid-layout>
                        <grid-layout-item class="mb-3 sm:w-1/2 md:w-1/3">
                            <div class="text-xs text-label">Name</div>
                            <div class="text-sm truncate">{{ file.name }}</div>
                        </grid-layout-item>

                        <grid-layout-item class="mb-3 sm:w-1/2 md:w-1/3">
                            <div class="text-xs text-label">Created</div>
                            <div class="text-sm">
                                {{ file.created_at | moment('D MMM YYYY') }}
                            </div>
                        </grid-layout-item>

                        <grid-layout-item
                            v-if="file.erased_at"
                            class="mb-3"
                        >
                            <div class="text-xs text-label">Deleted</div>
                            <div class="text-sm">
                                {{ file.erased_at | moment('D MMM YYYY') }}
                            </div>
                        </grid-layout-item>
                    </grid-layout>
                </div>

                <footer class="flex flex-col px-6 py-3 rounded-b md:flex-row-reverse bg-grey-bg">
                    <laroute-link
                        :to="{
                            name: 'storage.files.show',
                            params: {
                                file: file.uuid,
                                download: true
                            }
                        }"
                        class="w-full mb-3 btn btn-blue md:mb-0 md:w-auto md:ml-3"
                    >
                        Download
                    </laroute-link>

                    <button
                        type="button"
                        class="text-center btn"
                        @click.prevent="close"
                    >
                        Close
                    </button>
                </footer>
            </div>
        </modal-blue>
    </button>
</template>

<script>
    export default {
        props: {
            file: {
                type: Object,
                required: true
            },
            width: {
                type: Number,
                default: 150
            },
            height: {
                type: Number,
                default: 150
            }
        },
        data () {
            return {
                show_modal: false
            }
        },
        methods: {
            open () {
                setTimeout(() => {
                    this.show_modal = true
                }, 0)
            }
        }
    }
</script>
